import gql from 'graphql-tag';

const WearableSleepSummaryQuery = gql`
  query WearableSleepSummary($dateFrom: Date!, $dateTo: Date!) {
    wearable {
      sleepSummary(dateFrom: $dateFrom, dateTo: $dateTo) {
        date
        provider
        device
        startTime
        endTime
        durationMinutes
        timeInBedMinutes
        efficiencyPercent
        awakeMinutes
        lightMinutes
        deepMinutes
        remMinutes
        interruptionsCount
        napCount
        napDurationMinutes
        avgHeartRateBpm
        avgHrvSdnnMs
        avgRespiratoryRate
        avgSpo2Percent
      }
    }
  }
`;

export default WearableSleepSummaryQuery;
